import { triageV3 } from './triage';

export const get_url = (study_slug, data) =>
  triageV3({
    method: 'POST',
    url: `studies/${study_slug}/participant_engagements/upload_attachment_url`,
    data,
  });
